export const TYPE__ACTIVE = 'active';
export const TYPE__INACTIVE = 'inactive';

const LABELS = {
	[TYPE__ACTIVE]: 'Aktiv',
	[TYPE__INACTIVE]: 'Inaktiv',
};

export function getLabel (key)
{
	return LABELS[key];
}

export function getOptions ()
{
	return [
		{value: TYPE__ACTIVE, text: LABELS[TYPE__ACTIVE]},
		{value: TYPE__INACTIVE, text: LABELS[TYPE__INACTIVE]},
	];
}
